import { isNull } from 'lodash';
import React, { useRef } from 'react';
import { ILayerProps, IMarkupLayerProps } from '@meitu/saas-editor-core/es/version-types';
import LabelAction from '@meitu/saas-editor-ui/es/components/label-action';
import { useGlobalWidget } from '@meitu/saas-editor-ui/es/hooks/use-global-widget';
import { useListenActivePickLayerProps } from '@meitu/saas-editor-ui/es/hooks/use-listen-layer-props';
import { ColorGroup } from '@meitu/xdesign-widgets';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';

export const FillFeature: React.FC<{
    id: string;
    onAfterChange?: Function;
    trackCode?: string | number;
}> = React.memo(({ id, onAfterChange, trackCode }) => {
    const { $t } = useLocaleStore();
    const oldLayer = useRef<ILayerProps | null>(null);

    const color = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;
        const { fill } = layer.data as IMarkupLayerProps;
        return fill.color;
    });

    const colorGlobalWidgetRef = useGlobalWidget(editor, false);

    if (isNull(color)) return null;

    return (
        <div className="c-markup-panel__item ">
            <LabelAction title={$t((v) => v.panel.markupPanel.color)} align={true}>
                <ColorGroup
                    onOpenChange={(e) => {
                        colorGlobalWidgetRef.current = e;
                    }}
                    popupTriggerSize={{
                        width: 78,
                        height: 32,
                    }}
                    color={color}
                    setColor={(val: string) => {
                        if (oldLayer.current === null) {
                            const layer = editor.stage.getLayer(id, true);
                            oldLayer.current = layer;
                            editor.markupLayer.setAttrOperateOriginData(layer);
                        }
                        editor.markupLayer.setFillColor(id, val);
                    }}
                    setColorAfter={(val: string) => {
                        if (oldLayer.current) {
                            editor.markupLayer.setFillColor(oldLayer.current.id, val, oldLayer.current);
                        }
                        oldLayer.current = null;
                        editor.markupLayer.clearAttrOperateOriginData();
                        onAfterChange?.(trackCode);
                    }}
                    isGradient={false}
                    popupOverlayClassName="c-markup-panel__color-picker"
                    onToggleBizTab={(bizTab) => {
                        if (bizTab === 'team') {
                            window._stat_track?.('hb_layers_func_click', {
                                func_id: '8_107',
                            });
                        }
                    }}
                />
            </LabelAction>
        </div>
    );
});
